<script setup>
import {computed} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import UserProfilePic from '@/components/users/UserProfilePic.vue';
import {useNavigationItems} from '@/composables/useNavigationItems';
import {useAuthService} from '@/composables/useAuthService';

const router = useRouter();
const route = useRoute();

const {userTopRightItems, onUserTopRightItemClick} = useNavigationItems();
const {isAuthenticated, user} = useAuthService();
</script>
<template >
  <v-menu right offset-y v-if="isAuthenticated">
    <template v-slot:activator="{ props }">
      <v-list>
        <v-list-item height="64" class="ma-0 pl-2" v-bind="props">

          <user-profile-pic :image-clickable="false" size="medium" :user="user"></user-profile-pic>
          <v-icon color="textSubtle">mdi-chevron-down</v-icon>
        </v-list-item>
      </v-list>
    </template>
    <v-list density="compact">
      <v-list-item :to="{name : 'UserDashboard'}" exact>
        <v-list-item-title>
          <v-icon size="16">mdi-view-dashboard</v-icon>
          Admin dashboard
        </v-list-item-title>
      </v-list-item>
      <v-list-item exact v-for="(item, i) in userTopRightItems" :key="i" @click="onUserTopRightItemClick(item)">
        <v-list-item-title>
          <v-icon size="16" :icon="item.icon"></v-icon>
          {{ item.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>


<style scoped lang="scss">
.user-dropdown {
  font-size: 12px;
}
</style>
